import React from "react";
import { Request } from "../../hooks/Request";
import Circle from "../../components/Animation/Circle";
import InputSubDataFollowUpAdd from "../../components/Inputs/InputSubDataFollowUpAdd";

const FIELD_NAME = "historialDeSeguimiento";

export const FormQuotes = (props) => {
  const { procedure } = props;
  const procedureId = procedure.id || procedure.procedureId;

  const { data, loading } = Request({
    urlApi: `/Procedure/${procedureId}/datasets?fieldnames=${FIELD_NAME}`,
  });

  if (!loading) {
    return <Circle />;
  }

  const fieldData = data?.find((f) => f.name === FIELD_NAME);

  const field = {
    id: procedureId,
    fieldId: fieldData?.id,
    label: fieldData?.label || "Bitácora de Operaciones",
  };

  return <InputSubDataFollowUpAdd field={field} />;
};
